import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { useStatemachineContext } from "../../../context/StatemachineContext";
import { useTreeContext } from "../../../context/TreeDataContext";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import ActivityEditor from "./ActivityEditor";
import { useNavigate, useParams } from "react-router-dom";
import { getFolderFileById } from "../../../utils/treeData/folderEditorUtils";

const ActivityRenderer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [allStatesActivityObj, setAllStateActivityObj] = useState({
    states: {},
    activities: {}
  });
  const [activityForm, setActivityForm] = useState({});
  const [allJobs, setAllJobs] = useState({});
  const { smId, activityId } = useParams();
  const { activityData, setActivityData, setSelectedStateMachine } = useStatemachineContext();
  const navigate = useNavigate();
  const { stateMachineExplorerData } = useTreeContext();

  const handleNotesAndTag = (data, keyName) => {
    setActivityData({ ...activityData, [keyName]: data });
  };

  const fetchActivity = async () => {
    try {
      setIsLoading(true);
      setError("");
      const { data } = await axiosInstance.get(`/state-machine/${smId}/activities/${activityId}`);
      const { data: smData } = await axiosInstance.get(`/state-machine/${smId}`);

      setAllStateActivityObj({
        states: smData.config.states || [],
        activities: smData.config.activities || [],
        gateways: smData?.config?.gateways || []
      });
      setActivityForm(data.form);
      setActivityData(data);
    } catch (error) {
      setError(error?.response?.data?.message || "Something went wrong");
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllTemplatesAndJobs = async () => {
      try {
        const { data: postJobData } = await axiosInstance.get(`/jobs/filter?places=post_activity`);
        const { data: preJobData } = await axiosInstance.get(`/jobs/filter?places=pre_activity`);
        const { data: preSubmissionJobData } = await axiosInstance.get(`/jobs/filter?places=pre_submission`);

        setAllJobs({
          post_activity: postJobData,
          pre_activity: preJobData,
          pre_submission: preSubmissionJobData
        });
      } catch (error) {
        handleApiError(error);
      }
    };
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityId, smId]);

  useEffect(() => {
    if (!stateMachineExplorerData) return;
    const fileId = `${smId}/activities/${activityId}`;
    const file = getFolderFileById(stateMachineExplorerData, fileId);

    if (file) {
      const obj = {
        id: fileId,
        name: file.name,
        stateid: smId,
        statename: "states"
      };
      setSelectedStateMachine(obj);
    } else {
      navigate("../");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityId, smId]);

  if (isLoading) return <Loader />;

  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  return (
    <div className="sm_outer_section w_100">
      <ActivityEditor
        activityData={activityData}
        activityForm={activityForm}
        allStatesActivityObj={allStatesActivityObj}
        setActivityData={setActivityData}
        handleNotesAndTag={handleNotesAndTag}
        allJobs={allJobs}
      />
    </div>
  );
};

export default ActivityRenderer;
